import clabel from './CLabel.vue';
import cbutton from './CButton.vue';
import cfileupload from './CFileupload.vue';
import cinput from './CInput.vue';
import cdropdown from './CDropdown.vue';
import cdatepicker from './CDatepicker.vue';
import cmapautocomplete from './CMapAutocomplete.vue';
import ctable from './CTable.vue';
import ccheckbox from './CCheckbox.vue';
import ctimePicker from './CTimepicker.vue';
import cradioGroup from './CRadioGroup.vue';
import ccheckboxGroup from './CCheckboxGroup.vue';
import cdynamicGroup from './custom/CDynamicGroup.vue';
import ccustom_PackingMode from './custom/CPackingMode.vue';
import ccustom_FtOrderDetails from './custom/CFtOrderDetails.vue';
import ccustom_FtProcesses from './custom/CFtProcesses.vue';
import ccustom_ProductionReport from './custom/CProductionReport.vue';
import ccustom_InvoiceTotal from './custom/CInvoiceTotal.vue';
import ccustom_InvoiceDetails from './custom/CInvoiceDetails.vue';
import ccustom_QuotationDetails from './custom/CQuotationDetails.vue';
import ccustom_LoadingManifestDetails from './custom/CLoadingManifestDetails.vue';
import ccustom_CreditNoteDetails from './custom/CCreditNoteDetails.vue';
import ccustom_InvoicePaymentDetails from './custom/CInvoicePaymentDetails.vue';
import ccustom_CustomerStatementDetails from './custom/CCustomerStatementDetails.vue';
import ccustom_QtTermsCondtions from './custom/CQtTermsCondtions.vue';
import cpageComments from './CPageComments.vue';
import ccustom_LoadingManifestShippingDetails from './custom/CLoadingManifestShippingDetails.vue';
import csalesForecast from './CSalesForecast.vue';
import cmonthlyTarget from './CMonthlyTarget.vue';
import cqtItemsTable from './CQtItemsTable.vue';
import csalesRmAlias from './custom/CSalesRmAlias.vue';
import csalesTarget from './CSalesTarget.vue';
import csalesCollection from './CSalesCollection.vue';
import csalesFunnel from './CSalesFunnel.vue';
import csalesAging from './CSalesAging.vue';
import csalesComparison from './CSalesComparison.vue';
import csalesVariance from './CSalesVariance.vue';
import cquotationPrintView from './CQuotationPrintView.vue';


export const components = {
  clabel,
  cbutton,
  cinput,
  cpassword: cinput,
  cdropdown,
  cdatepicker,
  cmapautocomplete,
  ctable,
  cfileupload,
  ccheckbox,
  ctimePicker,
  cradioGroup,
  ccheckboxGroup,
  cdynamicGroup,
  ccustom_ProductionReport,
  ccustom_PackingMode,
  ccustom_FtOrderDetails,
  ccustom_InvoiceTotal,
  ccustom_FtProcesses,
  ccustom_InvoiceDetails,
  ccustom_LoadingManifestDetails,
  ccustom_CreditNoteDetails,
  ccustom_InvoicePaymentDetails,
  ccustom_QuotationDetails,
  ccustom_CustomerStatementDetails,
  ccustom_QtTermsCondtions,
  cpageComments,
  ccustom_LoadingManifestShippingDetails,
  csalesCollection,
  csalesForecast,
  cmonthlyTarget,
  cqtItemsTable,
  csalesRmAlias,
  csalesFunnel,
  csalesAging,
  csalesTarget,
  csalesComparison,
  csalesVariance,
  cquotationPrintView
}